import { For } from 'solid-js'

import { useI18n } from '../../i18n'
import {
   getRangeFilterConfig,
   RANGE_FILTER_KEYS,
   type RangeFilterKey,
} from '../../utils/timeRange'

type RangeFilterProps = {
   id?: string
   value: RangeFilterKey
   onChange: (key: RangeFilterKey) => void
}

/**
 * Renders the Week / Month / 3 Months / Year / Max chips.
 *
 * @param props - The active key and change handler.
 * @returns The chip row element.
 */
const RangeFilter = (props: RangeFilterProps) => {
   const t = useI18n()

   return (
      <div class="flex flex-wrap gap-2" id={props.id}>
         <For each={RANGE_FILTER_KEYS}>
            {key => (
               <button
                  type="button"
                  onClick={() => props.onChange(key)}
                  class="px-3 py-1.5 rounded-full text-sm border transition"
                  classList={{
                     'border-edge-strong bg-surface-control text-ink-soft':
                        props.value === key,
                     'border-edge bg-surface-raised text-ink-secondary hover:bg-surface-control':
                        props.value !== key,
                  }}
               >
                  {t(getRangeFilterConfig(key).labelKey)}
               </button>
            )}
         </For>
      </div>
   )
}

export default RangeFilter
